export default __webpack_public_path__ + "static/media/usfx3.9d23e39a.png";